const deleteTool = async ({ commit, rootGetters, dispatch }, toolId) => {
  commit("SET_DELETE_PROMT_LOADING", true);
  try {
    const customer = rootGetters["customer/CUSTOMER"];
    const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];

    const data = {
      id: toolId,
      customer_id: customer.customer_id,
    };

    if (customer.customer_id === 0) {
      data.customer_id = selected_customer.customer_id;
    }

    const response = await window.axios.delete("/proxy/prompts-tools", {
      data,
    });

    if (response && response.data.success) {
      commit("DELETE_TOOL", toolId);
      dispatch("notifications/pushNotification", "Deleted", { root: true });
    } else {
      throw response.data;
    }
  } catch (error) {
    dispatch("notifications/setError", error.message, { root: true });
  } finally {
    commit("SET_DELETE_TOOL_LOADING", false);
  }
};

export default deleteTool;
